import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/home/runner/work/express-add-ons-docs/express-add-ons-docs/node_modules/@adobe/gatsby-theme-aio/src/components/MDXFilter/index.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <p><a parentName="p" {...{
        "href": "../overview.md"
      }}>{`@express-document-sdk`}</a>{` / Point`}</p>
    <h1 {...{
      "id": "interface-point"
    }}>{`Interface: Point`}</h1>
    <p>{`Represents a 2D position.`}</p>
    <h2 {...{
      "id": "properties"
    }}>{`Properties`}</h2>
    <h3 {...{
      "id": "x"
    }}>{`x`}</h3>
    <p>{`• `}<strong parentName="p">{`x`}</strong>{`: `}<inlineCode parentName="p">{`number`}</inlineCode></p>
    <hr></hr>
    <h3 {...{
      "id": "y"
    }}>{`y`}</h3>
    <p>{`• `}<strong parentName="p">{`y`}</strong>{`: `}<inlineCode parentName="p">{`number`}</inlineCode></p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      